export class AuthError extends Error {
  constructor(message) {
    super(message);
    this.name = "AuthError";
  }
}

export class AIError extends Error {
  constructor(message) {
    super(message);
    this.name = "AIError";
  }
}


export class CommunityError extends Error {
  constructor(message) {
    super(message);
    this.name = "CommunityError";
  }
}

export class MediaError extends Error {
  constructor(message) {
    super(message);
    this.name = "MediaError";
  }
}

export class SearchError extends Error {
  constructor(message) {
    super(message);
    this.name = "SearchError";
  }
}

export class PaymentError extends Error {
  constructor(message) {
    super(message);
    this.name = "PaymentError";
  }
}

export class SystemError extends Error {
  constructor(message) {
    super(message);
    this.name = "SystemError";
  }
}
